import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {};

export const preamble: CSSProperties = {
  paddingBottom: 10,
};

export const row: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginBottom: 15,
};

export const toggle: CSSProperties = {
  marginRight: 10,
  marginLeft: -8,
};

export const primaryText: CSSProperties = {
  flexGrow: 1,
  color: greys.darkestGrey,
};

export const intro: CSSProperties = {
  color: greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
  paddingBottom: 15,
};

export const disabled: CSSProperties = {
  pointerEvents: "none",
  opacity: 0.4,
  WebkitFilter: "grayscale(45%)",
  filter: "grayscale(45%)",
};
